export default __webpack_public_path__ + "static/media/Helm of the Scattered Gods.d6231045.jpg";